import { useState } from 'react'
import { useParams } from 'react-router-dom'
import TextField from '@mui/material/TextField'
import { compose, path } from 'ramda'

import { useAppSelector } from 'src/store/hooks'
import TitleScreenStep from './title-screen'
import { selectActiveStep, selectSessionByID } from '../live.slice'
import Quiz from './quiz'

export default () => {
  let activeStep = useAppSelector(selectActiveStep)
  let { sessionID } = useParams()
  let session = useAppSelector(selectSessionByID(sessionID ?? ''))

  let [password, setPassword] = useState('')

  return (
    <div>
      {activeStep === 0 && <TitleScreenStep />}
      {activeStep === 1 &&
        (password.toLocaleLowerCase() ===
        session?.classQuizPasscode.toLocaleLowerCase() ? (
          <Quiz />
        ) : (
          <TextField
            style={{ marginTop: 50 }}
            className="mt-2"
            fullWidth
            variant="standard"
            label="Passcode"
            name="passcode"
            onChange={compose(setPassword, path(['target', 'value']) as any)}
          />
        ))}
    </div>
  )
}
